export default {
  // Common
  common: {
    welcome: '欢迎',
    loading: '加载中...',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    search: '搜索...',
    filter: '筛选',
    export: '导出',
    refresh: '刷新',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    confirm: '确认',
    yes: '是',
    no: '否',
    close: '关闭',
    actions: '操作',
    status: '状态',
    active: '活跃',
    inactive: '非活跃',
    enabled: '已启用',
    disabled: '已禁用',
    success: '成功',
    error: '错误',
    warning: '警告',
    info: '信息',
    apply: '应用',
    download: '下载',
    upload: '上传',
    view: '查看',
    details: '详情',
    name: '名称',
    email: '邮箱',
    phone: '电话',
    address: '地址',
    country: '国家',
    city: '城市',
    state: '省/州',
    zipCode: '邮政编码',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    description: '描述',
    type: '类型',
    amount: '金额',
    date: '日期',
    time: '时间',
    from: '从',
    to: '至',
    all: '全部',
    none: '无',
    select: '选择',
    selected: '已选',
    total: '总计',
    subtotal: '小计',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    completed: '已完成',
    failed: '失败',
    processing: '处理中',
    cancelled: '已取消',
    required: '必填',
    optional: '可选',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本周',
    thisMonth: '本月',
    lastMonth: '上月',
    custom: '自定义',
    range: '范围',
    noData: '暂无数据',
    noResults: '未找到结果',
    showMore: '显示更多',
    showLess: '显示更少',
    expand: '展开',
    collapse: '收起',
    clearAll: '清除全部',
    selectAll: '全选',
    deselectAll: '取消全选',
    copyToClipboard: '复制到剪贴板',
    copied: '已复制！',
    notAvailable: '不适用',
    upgrade: '升级',
  },

  // Auth
  auth: {
    login: '登录',
    logout: '退出',
    email: '邮箱',
    password: '密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    signIn: '登录',
    signUp: '注册',
    loginSuccess: '登录成功',
    loginError: '邮箱或密码无效',
    sessionExpired: '会话已过期，请重新登录。',
    adminPanel: '管理面板',
    needHelp: '需要帮助？',
    poweredBy: '技术支持：',
  },

  // Navigation
  nav: {
    dashboard: '仪表盘',
    instruments: '交易品种',
    clients: '客户',
    accounts: '账户',
    trading: '交易',
    reports: '报告',
    auditLog: '审计日志',
    withdrawals: '提款',
    deposits: '存款',
    settings: '设置',
    plugins: '插件',
    accountGroups: '账户组',
    kyc: 'KYC',
    apiDocs: 'API 文档',
    notifications: '通知',
    upgrade: '升级',
    groupPricing: '组定价',
  },

  // Dashboard
  dashboard: {
    title: '仪表盘',
    overview: '概览',
    stats: '统计',
    totalClients: '客户总数',
    totalAccounts: '账户总数',
    openPositions: '未平仓',
    todayPnL: '今日盈亏',
    liveAccounts: '真实账户',
    demoAccounts: '模拟账户',
    activeClients: '活跃客户',
    activeTraders: '活跃交易者',
    newClients: '新客户',
    volumeChart: '交易量（7天）',
    pnlTrend: '盈亏趋势（30天）',
    recentActivity: '最近活动',
    quickActions: '快速操作',
    financialOverview: '财务概览',
    financialOverview30Days: '财务概览（30天）',
    riskAlerts: '风险警报',
    riskDistribution: '风险分布',
    currentPlan: '当前套餐',
    planUsage: '套餐使用情况',
    allowedMarkets: '可用市场',
    accountOverview: '账户概览',
    activeUsers: '活跃用户',
    activeThisMonth: '本月活跃',
    plan: '套餐',
    feedLatency: '行情延迟',
    expires: '到期时间',
    cashFlowComparison: '现金流对比',
    totalTransactions: '总交易笔数',
    totalDeposits: '总存款',
    totalWithdrawals: '总提款',
  },

  // Instruments
  instruments: {
    title: '交易品种管理',
    library: '品种库',
    enabled: '已启用品种',
    feed: '行情品种',
    symbol: '代码',
    category: '类别',
    priceScale: '价格精度',
    leverage: '杠杆',
    spread: '点差',
    commission: '佣金',
    enable: '启用',
    disable: '禁用',
    bulkEnable: '批量启用',
    settings: '设置',
    tradeMode: '交易模式',
    executionType: '执行类型',
    forex: '外汇',
    crypto: '加密货币',
    stocks: '股票',
    indices: '指数',
    commodities: '大宗商品',
    general: '常规',
    leverageLots: '杠杆与手数',
    spreads: '点差',
    commissions: '佣金',
    riskManagement: '风险管理',
    advanced: '高级',
    maxLeverage: '最大杠杆',
    minLotSize: '最小手数',
    maxLotSize: '最大手数',
    lotStep: '手数步长',
    spreadType: '点差类型',
    spreadMarkup: '点差加成',
    fixedSpread: '固定点差',
    commissionPerLot: '每手佣金',
    commissionType: '佣金类型',
    stopLevel: '止损水平',
    freezeLevel: '冻结水平',
    maxPositions: '最大持仓数',
    enableSuccess: '品种已成功启用',
    disableSuccess: '品种已成功禁用',
    updateSuccess: '设置已成功更新',
    bulkEnableSuccess: '品种已批量启用',
  },

  // Clients
  clients: {
    title: '客户',
    clientsList: '客户列表',
    clientDetails: '客户详情',
    name: '姓名',
    email: '邮箱',
    phone: '电话',
    country: '国家',
    kycStatus: 'KYC 状态',
    accountCount: '账户数',
    totalBalance: '总余额',
    lastLogin: '最后登录',
    createdAt: '创建时间',
    verified: '已验证',
    pending: '待审核',
    rejected: '已拒绝',
    searchPlaceholder: '搜索客户...',
    nameOrEmail: '姓名或邮箱…',
    editClient: '编辑客户',
    configureOverride: '配置用户覆盖',
    noClientsFound: '未找到客户',
  },

  // Accounts
  accounts: {
    title: '账户',
    accountsList: '账户列表',
    accountDetails: '账户详情',
    accountNumber: '账户号码',
    accountType: '账户类型',
    accountGroup: '账户组',
    accountSettings: '账户设置',
    accountState: '账户状态',
    accountActive: '账户活跃',
    balance: '余额',
    equity: '净值',
    margin: '保证金',
    freeMargin: '可用保证金',
    marginLevel: '保证金水平',
    leverage: '杠杆',
    credit: '信用额度',
    debit: '扣款',
    adjustBalance: '调整余额',
    changeLeverage: '修改杠杆',
    live: '真实',
    demo: '模拟',
    searchPlaceholder: '按账户号码或邮箱搜索...',
    accountNumberOrEmail: '账户号码或邮箱…',
    balanceChange: '余额变动',
    reasonForAdjustment: '调整原因...',
    accountUpdatedSuccess: '账户已成功更新',
    noAccountsFound: '未找到账户',
  },

  // Trading
  trading: {
    title: '交易',
    positions: '持仓',
    orders: '订单',
    history: '历史',
    symbol: '代码',
    side: '方向',
    volume: '手数',
    openPrice: '开仓价',
    currentPrice: '当前价',
    pnl: '盈亏',
    buy: '买入',
    sell: '卖出',
    open: '开仓',
    pending: '挂单',
    closed: '已平仓',
    closedAt: '平仓时间',
    openedAt: '开仓时间',
    price: '价格',
    totalTrades: '总交易数',
    winningTrades: '盈利交易',
    losingTrades: '亏损交易',
    totalPnL: '总盈亏',
    account: '账户',
    status: '状态',
    swap: '隔夜利息',
    commission: '佣金',
    ticket: '单号',
    noPositions: '暂无未平仓',
    noOrders: '暂无挂单',
    noHistory: '暂无交易历史',
    bid: '买价',
    ask: '卖价',
    tradingManagement: '交易管理',
    liveMonitoring: '实时监控',
    disconnected: '已断开',
    activeTraders: '活跃交易者',
    openPositions: '未平仓',
    pendingOrders: '挂单',
    floatPnL: '浮动盈亏',
    accountState: '账户状态',
    marginCall: '追加保证金',
    stopOutRisk: '强平风险',
    live: '实时',
    offline: '离线',
    snapshot: '快照',
    marginLvl: '保证金水平',
    openTrades: '未平仓交易',
    freeMargin: '可用保证金',
    marginUsed: '已用保证金',
    balance: '余额',
    equity: '净值',
    credit: '信用',
    slTp: '止损/止盈',
    fees: '费用',
    netPnL: '净盈亏',
    grossPnL: '毛盈亏',
    reason: '原因',
    openedClosed: '开仓/平仓',
    closePrice: '平仓价',
    reserved: '已预留',
    reservedMargin: '预留保证金',
    created: '创建时间',
    triggerPrice: '触发价',
    duration: '持续时间',
    closedTrades: '已平仓交易',
    activeTrades: '活跃',
    stopLoss: '止损',
    takeProfit: '止盈',
    closePosition: '平仓',
    cancelOrder: '取消订单',
    modifyPosition: '修改持仓',
    thisActionCannotBeUndone: '此操作无法撤销',
    enterStopLoss: '输入止损价',
    enterTakeProfit: '输入止盈价',
    filterTrading: '筛选交易',
    traderSymbolAccount: '交易者、代码、账户…',
    noFound: '未找到{tab}',
    showingOf: '显示 {from}–{to}，共 {total} 个交易者',
    traderCount: '{count} 位交易者 · {total} 个{tab}',
    positionClosedSuccess: '持仓已成功平仓',
    orderCancelledSuccess: '订单已成功取消',
    positionModifiedSuccess: '持仓已成功修改',
    failedToClosePosition: '平仓失败',
    failedToCancelOrder: '取消订单失败',
    failedToModifyPosition: '修改持仓失败',
    invalidPosition: '无效持仓：缺少 ID',
  },

  // Reports
  reports: {
    title: '报告',
    exposure: '风险敞口报告',
    profitability: '客户盈利能力',
    daily: '日报',
    dateRange: '日期范围',
    totalExposure: '总风险敞口',
    netVolume: '净交易量',
    topWinners: '盈利排行',
    topLosers: '亏损排行',
    buyVolume: '买入量',
    sellVolume: '卖出量',
    positionCount: '持仓数量',
    winRate: '胜率',
    rank: '排名',
    client: '客户',
    noData: '暂无数据',
    totalVolume: '总交易量',
    commission: '佣金',
    activeAccounts: '活跃账户',
    export: '导出',
    download: '下载',
    positions: '持仓',
    trades: '交易',
    winning: '盈利',
    losing: '亏损',
  },

  // Settings
  settings: {
    title: '设置',
    brokerInfo: '经纪商信息',
    brokerSettings: '经纪商设置',
    brokerName: '经纪商名称',
    brokerNameRequired: '经纪商名称 *',
    brokerLogo: '经纪商标志',
    brokerStatus: '经纪商状态',
    domain: '域名',
    primaryColor: '主色调',
    secondaryColor: '辅助色',
    logo: '标志',
    supportEmail: '支持邮箱',
    supportPhone: '支持电话',
    generalInfo: '基本信息',
    branding: '品牌设置',
    accountGroups: '账户组',
    addNewGroup: '添加新组',
    createFirstGroup: '创建第一个组',
    noGroupsFound: '未找到账户组',
    default: '默认',
    maxLeverage: '最大杠杆',
    marginCall: '追加保证金',
    stopOut: '强平',
    commission: '佣金',
    maxLotSize: '最大手数',
    execution: '执行',
    hedgingAllowed: '允许对冲',
    scalpingAllowed: '允许剥头皮',
    eaTrading: 'EA 交易',
    nbpEnabled: '启用 NBP',
    saving: '保存中...',
    groupName: '组名称',
    description: '描述',
    editGroup: '编辑组',
    deleteGroup: '删除组',
    cannotDeleteDefault: '无法删除默认组',
    confirmDelete: '确定要删除"{name}"吗？此操作无法撤销。',
    groupCreatedSuccess: '组已成功创建',
    groupUpdatedSuccess: '组已成功更新',
    groupDeletedSuccess: '组已成功删除',
    failedToSave: '保存组失败',
    failedToDelete: '删除组失败',
    failedToLoad: '加载账户组失败',
    configureYourBroker: '配置您的经纪商信息和偏好设置',
    loadingSettings: '加载设置中...',
    legalName: '法定名称',
    licenseNumber: '许可证号',
    environment: '环境',
    contactInformation: '联系信息',
    readOnly: '只读',
    readOnlyContactSupport: '只读——如需更改请联系支持',
    supportedLanguages: '支持的语言',
    selectLanguagesDescription: '选择客户门户中可用的语言。至少需要选择一种语言。',
    systemLimits: '系统限制',
    maxAccounts: '最大账户数',
    maxConcurrentTrades: '最大并发交易数',
    maintenanceMode: '维护模式',
    enableMaintenanceMode: '启用维护模式',
    maintenanceModeDescription: '启用后，客户将看到维护消息而非平台',
    maintenanceMessage: '维护消息',
    maintenanceMessagePlaceholder: '我们正在进行计划维护，请稍后再试。',
    saveChanges: '保存更改',
    howToConnectDomain: '如何连接您的域名',
    unlockToEdit: '解锁以编辑域名',
    lockDomain: '锁定域名',
    changingDomainWarning: '更改域名可能导致客户无法访问。确定要解锁吗？',
    changingDomainWarningLong: '更改域名可能暂时导致客户无法访问及 DNS 设置失效。确定要解锁吗？',
    domainBreakWarning: '⚠️ 更改域名可能暂时影响现有客户访问',
    domainBreakWarningLong: '⚠️ 更改域名可能暂时影响现有客户访问和 DNS 路由',
  },

  // Account Groups
  accountGroups: {
    title: '账户组',
    activeGroups: '活跃',
    defaultGroups: '默认',
    addNewGroup: '添加新组',
    createFirstGroup: '创建第一个组',
    noGroupsFound: '未找到账户组',
    groupDetails: '组详情',
    pricingOverrides: '定价覆盖',
    riskSettings: '风险设置',
    tradingSettings: '交易设置',
  },

  // Group Pricing
  groupPricing: {
    title: '组定价覆盖',
    infoBanner: '账户组定价覆盖',
    infoDescription: '为整个账户组配置自定义定价。留空（NULL）则使用经纪商默认设置。',
    editPricingOverrides: '编辑定价覆盖',
    spreadMarkup: '点差加成',
    spreadMarkupPips: '点差加成（点）',
    commission: '佣金',
    commissionPerLot: '每手佣金（美元）',
    maxLeverageOverride: '最大杠杆覆盖',
    brokerDefault: '经纪商默认',
    useBrokerDefault: '使用经纪商默认',
    clearUseBrokerDefault: '清除（使用经纪商默认）',
    saveOverrides: '保存覆盖',
    overridesUpdatedSuccess: '组定价覆盖已成功更新',
    failedToUpdate: '更新覆盖失败',
    leaveEmptyInfo: '留空则使用经纪商默认设置。仅设置需要覆盖此组的值。',
    pips: '点',
    perLot: '/手',
  },

  // KYC
  kyc: {
    title: 'KYC 仪表盘',
    allKyc: '全部 KYC',
    allStatus: '全部状态',
    allKycStatus: '全部 KYC 状态',
    pending: '待审核',
    approved: '已批准',
    rejected: '已拒绝',
    verified: '已验证',
    actionNeeded: '需要操作',
    awaitingAction: '等待操作',
    allCaughtUp: '全部处理完毕！',
    noApplications: '目前没有待处理的 KYC 申请。',
    searchPlaceholder: '按姓名、邮箱或 ID 搜索...',
    nameEmailOrId: 'ID、姓名或邮箱…',
    confirmApproval: '确认 KYC 批准',
    confirmRejection: '确认拒绝——请输入原因（必填）。',
    rejectionReason: '请说明拒绝此申请的原因（必填）',
    approveSuccess: 'KYC 已成功批准',
    rejectSuccess: 'KYC 已成功拒绝',
    failedToApprove: 'KYC 批准失败',
    failedToReject: 'KYC 拒绝失败',
    basicVerified: '基础认证',
    fullVerified: '完整认证',
    allApplications: '全部申请',
    kycVerification: 'KYC 验证',
    reviewManageDesc: '审核和管理客户验证申请',
    pluginSettings: '插件设置',
    reviewKycApplication: '审核 KYC 申请',
    verificationLevel: '验证级别',
    personalInformation: '个人信息',
    fullName: '全名',
    dateOfBirth: '出生日期',
    nationality: '国籍',
    addressLabel: '地址',
    sourceOfFunds: '资金来源',
    noPersonalData: '尚未提交个人数据',
    uploadedDocuments: '已上传文件',
    noDocumentsUploaded: '尚未上传文件',
    yourDecision: '您的决定',
    approve: '批准',
    reject: '拒绝',
    rejectionReasonLabel: '拒绝原因',
    submitting: '提交中…',
    submitReview: '提交审核',
    previewNotAvailable: '预览不可用',
    downloadFile: '下载文件',
    uploaded: '已上传',
    pendingReview: '待审核',
    allLevels: '全部级别',
    allStatuses: '全部状态',
    allActions: '全部操作',
    userCol: '用户',
    currentLevel: '当前级别',
    docsCol: '文件',
    lastUpdated: '最后更新',
    levelCol: '级别',
    actionCol: '操作',
    performedBy: '操作人',
    detailsCol: '详情',
    dateTime: '日期和时间',
    submittedCol: '提交时间',
    noApplicationsFound: '未找到申请',
    noAuditRecords: '未找到审计记录',
    noMatchingApplications: '没有匹配的申请',
    noPendingApplications: '没有待处理申请',
    systemAuto: '系统（自动）',
    admin: '管理员',
    traderLabel: '交易者',
    upgradedTo: '升级至',
    pendingApplications: '条待处理申请',
    pendingApplicationsPlural: '条待处理申请',
    users: '位用户',
    usersPlural: '位用户',
    records: '条记录',
    recordsPlural: '条记录',
    applications: '条申请',
    applicationsPlural: '条申请',
    totalUsers: '总用户数',
    basicVerifiedStat: '基础认证',
    moderateVerified: '中级认证',
    fullyVerified: '完整认证',
    pendingSuffix: '+{count} 待处理',
    levelBasic: '基础',
    levelModerate: '中级',
    levelVerified: '已验证',
    notStarted: '未开始',
    none: '无',
    unknown: '未知',
    review: '审核',
    auditLog: '审计日志',
    requiredDocuments: '所需文件',
    requiredDocsDesc: '选择交易者每个 KYC 级别必须上传的文件。每个级别至少需要一个文件。',
    kycDocuments: '{level} KYC 文件',
    selected: '已选 {count} 项',
    approvalMode: '审批模式',
    manualReview: '人工审核',
    autoApprove: '自动批准',
    autoApproveLevels: '自动批准级别',
    basicKyc: '基础 KYC',
    moderateKyc: '中级 KYC',
    verifiedKyc: '完整 KYC',
    enforceOnDeposit: '存款时强制 KYC',
    enforceOnWithdrawal: '提款时强制 KYC',
    basic: '基础',
    moderate: '中级',
    verified: '已验证',
    howItWorks: '运作方式：',
    howItWorksBullet1: '低于基础阈值：无需 KYC',
    howItWorksBullet2: '高于基础阈值：需要基础 KYC',
    howItWorksBullet3: '高于中级阈值：需要中级 KYC',
    howItWorksBullet4: '高于完整阈值：需要完整验证',
    saveConfiguration: '保存配置',
    savingConfiguration: '保存中...',
    openKycDashboard: '打开 KYC 仪表盘',
    enableToViewStats: '启用插件以查看统计信息',
    statNone: '无',
    docGovIdFrontLabel: '政府颁发的身份证件（正面）',
    docGovIdFrontDesc: '护照、驾照或国民身份证——正面',
    docGovIdBackLabel: '政府颁发的身份证件（背面）',
    docGovIdBackDesc: '身份证件背面',
    docSelfieLabel: '手持证件自拍',
    docSelfieDesc: '手持证件与面部同框的照片',
    docProofAddressLabel: '地址证明',
    docProofAddressDesc: '水电费账单或银行对账单（3个月内）',
    docBankStatementLabel: '银行对账单',
    docBankStatementDesc: '显示姓名和账户的近期对账单',
    docSourceFundsLabel: '资金来源证明',
    docSourceFundsDesc: '证明交易资金来源的文件',
    docEmploymentLabel: '雇佣证明信',
    docEmploymentDesc: '雇主确认函',
    docTaxIdLabel: '税务证件',
    docTaxIdDesc: '税务识别证书',
    docOtherLabel: '其他文件',
    docOtherDesc: '其他支持性文件',
    auditActions: {
      submitted: '已提交',
      approved: '已批准',
      rejected: '已拒绝',
      document_uploaded: '文件已上传',
      document_approved: '文件已批准',
      document_rejected: '文件已拒绝',
      level_upgraded: '级别已升级',
      resubmission: '重新提交',
    },
  },

  // Deposits
  deposits: {
    title: '存款',
    allDeposits: '全部存款',
    allStatuses: '全部状态',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    completed: '已完成',
    searchPlaceholder: '搜索存款…',
    searchByIdNameEmail: '按 ID、交易者姓名或邮箱搜索…',
    idNameOrEmail: 'ID、姓名或邮箱…',
    depositProof: '存款凭证',
    depositProofPdf: '存款凭证 PDF',
    amount: '金额',
    method: '方式',
    status: '状态',
    trader: '交易者',
    date: '日期',
    actions: '操作',
    approve: '批准',
    reject: '拒绝',
    confirmApproval: '确认批准——这将为交易者的账户余额充值。',
    confirmRejection: '确认拒绝——请输入原因（可选）。',
    rejectionReason: '拒绝原因（可选）…',
    approveSuccess: '存款已成功批准',
    rejectSuccess: '存款已成功拒绝',
    failedToApprove: '批准存款失败',
    failedToReject: '拒绝存款失败',
    noDepositsFound: '未找到存款记录',
    proofThumbnail: '凭证缩略图',
    zoomIn: '放大',
    zoomOut: '缩小',
    openInNewTab: '在新标签页中打开',
    bank: '银行',
    crypto: '加密货币',
    card: '银行卡',
    bankPerCountry: '银行（按国家）',
    bankPerUser: '银行（按用户）',
    bankTransfer: '银行转账',
    bankTransferPerCountry: '银行转账（按国家）',
    bankTransferPerUser: '银行转账（按用户）',
    averageDeposit: '平均存款',
  },

  // Withdrawals
  withdrawals: {
    title: '提款',
    allWithdrawals: '全部提款',
    allStatuses: '全部状态',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    completed: '已完成',
    searchPlaceholder: '搜索提款…',
    searchByIdNameEmail: '按 ID、交易者姓名或邮箱搜索…',
    idNameOrEmail: 'ID、姓名或邮箱…',
    amount: '金额',
    method: '方式',
    status: '状态',
    trader: '交易者',
    date: '日期',
    actions: '操作',
    approve: '批准',
    reject: '拒绝',
    confirmApproval: '确认批准——资金将释放至交易者的收款账户。',
    confirmWithdrawalApproval: '确认提款批准——资金将释放至交易者的收款账户。',
    confirmRejection: '确认拒绝——请输入原因（可选）。',
    rejectionReason: '拒绝原因（可选）…',
    approveSuccess: '提款已成功批准',
    rejectSuccess: '提款已成功拒绝',
    failedToApprove: '批准提款失败',
    failedToReject: '拒绝提款失败',
    noWithdrawalsFound: '未找到提款记录',
    averageWithdrawal: '平均提款',
  },

  // Audit Log
  auditLog: {
    title: '审计日志',
    allActions: '全部操作',
    allEvents: '全部事件',
    allLevels: '全部级别',
    searchPlaceholder: '搜索审计日志…',
    emailActionOrId: '邮箱、操作或 ID…',
    event: '事件',
    user: '用户',
    action: '操作',
    timestamp: '时间戳',
    details: '详情',
    level: '级别',
    info: '信息',
    warning: '警告',
    error: '错误',
    critical: '严重',
    noLogsFound: '未找到审计日志',
    administrativeAction: '已记录一项管理操作。',
    filterAuditLog: '筛选审计日志',
    reset: '重置',
    eventType: '事件类型',
    apply: '应用',
    totalEvents: '总事件数',
    depositEvents: '存款事件',
    withdrawalEvents: '提款事件',
    noEventsMatch: '没有匹配此筛选条件的事件',
    noEntriesMatch: '没有匹配当前筛选条件的审计条目。',
    showAll: '显示全部',
    events: '个事件',
    eventsPlural: '个事件',
    totalEventsRecorded: '已记录的总事件数',
    performedBy: '操作人',
    amount: '金额',
    paymentMethod: '付款方式',
    balanceChange: '余额变动',
    statusChange: '状态变更',
    rejectionReason: '拒绝原因',
    actionWithdrawalRequested: '已申请提款',
    actionDepositSubmitted: '已提交存款',
    actionProofUploaded: '已上传凭证',
    actionDepositApproved: '存款已批准',
    actionDepositRejected: '存款已拒绝',
    actionWithdrawalApproved: '提款已批准',
    actionWithdrawalRejected: '提款已拒绝',
    actionFundsLocked: '资金已冻结',
    actionFundsReturned: '资金已退还',
    fundsLockedSummary: '交易者账户资金已冻结，等待提款审核。',
    fundsReturnedSummary: '被拒绝后，冻结资金已退还给交易者。',
    depositsTab: '存款',
    withdrawalsTab: '提款',
  },

  // Plugins
  plugins: {
    title: '插件',
    backToPlugins: '返回插件',
    searchPlaceholder: '搜索插件…',
    countrySelectNoMatch: '无匹配',
    configurePlugin: '配置插件',
    pressEscToClose: '按 {key} 关闭',
    loadingUsers: '加载中…',
    available: '可用',
    active: '活跃',
    activate: '激活',
    deactivate: '停用',
    configure: '配置',
    documentation: '文档',
    settings: '设置',
    noPluginsFound: '未找到插件',
    pluginDetails: '插件详情',
    version: '版本',
    author: '作者',
    description: '描述',
    filterInactive: '未激活',
    paymentGateways: '支付网关',
    stripeTitle: 'Stripe',
    stripeDescription: '通过 Stripe 接受付款',
    paypalTitle: 'PayPal',
    paypalDescription: '通过 PayPal 接受付款',
    communicationTools: '通信工具',
    twilioTitle: 'Twilio 短信',
    twilioDescription: '发送短信通知',
    mailgunTitle: 'Mailgun',
    mailgunDescription: '邮件发送服务',
    bankFieldAccountHolder: '账户持有人',
    bankFieldBankName: '银行名称',
    bankFieldAccountNumber: '账号',
    bankFieldRoutingNumber: '路由号码（可选）',
    bankFieldSetAsDefault: '设为默认（全局备用）',
    copyTradingTitle: '跟单交易',
    copyTradingDescription: '启用跟单交易功能',
    tradingTools: '交易工具',
    mam: 'MAM/PAMM',
    apiKey: 'API 密钥',
    apiSecret: 'API 密钥',
    accountSid: '账户 SID',
    authToken: '授权令牌',
    authDomain: '授权域名',
    appId: '应用 ID',
    loadingPlugins: '加载插件中…',
    noPluginsMatch: '没有插件匹配您的条件',
    tryDifferentSearch: '尝试不同的搜索或筛选',
    tryAdjustingSearch: '尝试调整您的搜索或筛选',
    activeCount: '{count} 活跃 · {owned} 已拥有 · {available} 在商店',
    ofPurchasedActive: '已购买的 {count} 个中活跃',
    expired: '已过期',
    expires: '到期时间',
    free: '免费',
    buyPlugin: '购买 — ${price}{cycle}',
    openInFullPage: '在完整页面中打开',
    noConfigPanel: '此插件没有可用的配置面板。',
    currentStatus: '当前状态',
    failedToUpdateKyc: '更新 KYC 配置失败',
    filterAll: '全部',
    filterActive: '活跃',
    filterOwned: '已拥有',
    filterStore: '商店',
    pluginNotFound: '未找到插件',
    loadingPlugin: '加载插件中...',
    failedToLoadPlugin: '加载插件失败',
    noConfigAvailable: '此插件没有可用的配置面板。',
    activeStatus: '活跃',
    editLabel: '编辑',
    newLabel: '新建',
    addLabel: '添加',
    saveLabel: '保存',
    cancelLabel: '取消',
    globalBankAccount: '全局银行账户',
    addBankAccount: '添加银行账户',
    defaultLabel: '（默认）',
    cryptoWallet: '加密货币钱包',
    addCryptoWallet: '添加加密货币钱包',
    coinPlaceholder: '币种（如 BTC）',
    networkPlaceholder: '网络（如主网）',
    walletAddressPlaceholder: '钱包地址',
    labelOptionalPlaceholder: '标签（可选）',
    paymentLink: '支付链接',
    addPaymentLink: '添加支付链接',
    linkNamePlaceholder: '名称（如 Stripe Checkout）',
    perUserBankAccount: '按用户银行账户',
    addUserBankMapping: '添加用户→银行映射',
    editExistingAccount: '编辑现有账户',
    assignedUsers: '已分配用户',
    pickTraders: '选择交易者',
    searchAddTrader: '搜索并添加交易者…',
    perCountryBankAccount: '按国家银行账户',
    addCountryBankMapping: '添加国家→银行映射',
    mappedCountries: '已映射国家',
    pickCountries: '选择国家',
    searchAddCountries: '搜索并添加国家…',
    badgeActive: '活跃',
    badgeInactive: '未激活',
    badgeExpired: '已过期',
    purchasePlugin: '购买插件',
    paymentMethod: '付款方式',
    generatePaymentAddress: '生成付款地址',
    sendExactly: '精确发送',
    toAddressBelow: '至以下地址',
    paymentAddress: '付款地址',
    waitingForPayment: '等待付款...',
    paymentDetected: '检测到付款！确认中...',
    confirmationsReceived: '已收到 {count} 个确认',
    confirmationsReceivedPlural: '已收到 {count} 个确认',
    expiresIn: '到期时间：',
    paymentId: '付款 ID：',
    paymentConfirmed: '付款已确认！',
    pluginActivated: '{name} 已激活。',
    networkError: '网络错误，请重试。',
    failedToCreatePayment: '创建付款失败',
    paymentExpired: '付款窗口已过期，请创建新的付款。',
  },

  // API Docs
  apiDocs: {
    title: 'API 文档',
    authentication: '身份验证',
    baseUrl: '基础 URL：',
    allRequestsRequire: '所有请求需要两个请求头：',
    apiKeyManagement: '具有权限控制的 API 密钥管理',
    billing: '账单',
    apiAccess: 'API 访问',
    apiAccessAddon: 'API 访问附加组件已激活',
    buyAddon: '购买附加组件 — $199/月',
    getAccounts: 'GET /accounts',
    getAccountDetails: 'GET /accounts/:id',
    updateAccount: 'PATCH /accounts/:id',
    getDeposits: 'GET /deposits',
    approveDeposit: 'POST /deposits/:id/approve',
    rejectDeposit: 'POST /deposits/:id/reject',
    getWithdrawals: 'GET /withdrawals',
    approveWithdrawal: 'POST /withdrawals/:id/approve',
    rejectWithdrawal: 'POST /withdrawals/:id/reject',
    approvalsDescription: '以编程方式批准存款和提款',
    approveDepositDesc: '批准存款（状态必须为 proof_uploaded）。为账户余额充值，记录交易，通知引擎。请求体：notes?。返回 balance_before 和 balance_after。',
    approveWithdrawalDesc: '批准待处理的提款。余额已在申请时锁定。请求体：notes?',
    restApi: 'REST API',
    baseUrlLabel: '基础 URL：',
    yourApiKeys: '您的 API 密钥',
    noApiKeysYet: '暂无 API 密钥',
    generateNewKey: '生成新密钥',
    revokeKey: '撤销',
    rateLimit: '频率限制',
    maxKeys: '最大密钥数',
    reqPerMin: '{limit} 请求/分钟',
    exampleRequest: '示例请求',
    queryParameters: '查询参数',
    endpoints: '个端点',
    endpointsPlural: '个端点',
    includedInPlan: '包含在您的企业版套餐中',
    addonActive: 'API 访问附加组件已激活',
    restApiAccess: 'REST API 访问',
    restApiDesc: 'REST API 访问在企业版套餐中提供，或作为任何套餐的独立附加组件。将您的系统直接连接到经纪商平台。',
    featureReadClients: '读取客户、账户和交易历史',
    featureApprovePayments: '以编程方式批准存款和提款',
    featureApiKeyManagement: '具有权限控制的 API 密钥管理',
    featureRateLimit: '每个密钥每分钟最多 60 个请求',
    featureInteractiveDocs: '仪表盘中的交互式文档',
    upgradeToEnterprise: '升级至企业版',
    buyAddonPrice: '购买附加组件 — $199/月',
    generateApiKey: '生成 API 密钥',
    keyName: '密钥名称',
    keyNamePlaceholder: '例如：生产环境密钥',
    scopes: '权限范围',
    generating: '生成中...',
    generateKey: '生成密钥',
    keyGenerated: '密钥已生成',
    copySecretWarning: '⚠️ 现在复制您的密钥——之后将不再显示。',
    apiKeyLabel: 'API 密钥',
    apiSecretLabel: 'API 密钥',
    done: '完成',
    enterKeyName: '输入密钥名称',
    failedToCreateKey: '创建密钥失败',
    keyRevoked: '密钥已撤销',
    confirmRevoke: '撤销此 API 密钥？此操作无法撤销。',
  },

  // Notifications
  notifications: {
    title: '通知设置',
    emailNotifications: '邮件通知',
    smsNotifications: '短信通知',
    pushNotifications: '推送通知',
    deposits: '存款',
    withdrawals: '提款',
    newClients: '新客户',
    kycApplications: 'KYC 申请',
    systemAlerts: '系统警报',
    enabled: '已启用',
    disabled: '已禁用',
    saveSettings: '保存设置',
    settingsSaved: '设置已成功保存',
    notificationChannels: '通知渠道',
    configureChannels: '配置平台向客户发送提醒的方式。仅启用您已设置的渠道。',
    saveAll: '全部保存',
    saving: '保存中...',
    enableToConfigure: '启用以配置 {title}',
    emailSmtp: '邮件（SMTP）',
    emailSmtpSubtitle: '通过您自己的 SMTP 服务器发送邮件',
    recommended: '推荐',
    smtpHost: 'SMTP 主机',
    smtpPort: 'SMTP 端口',
    usernameEmail: '用户名/邮箱',
    passwordAppPassword: '密码/应用密码',
    fromEmail: '发件人邮箱',
    fromName: '发件人名称',
    useTls: '使用 TLS / STARTTLS',
    useTlsHint: '推荐用于端口 587。端口 465（SSL）请禁用。',
    sendTestEmail: '发送测试邮件',
    pushFcm: '推送通知（FCM）',
    pushFcmSubtitle: '适用于 Android、iOS 和 Web 的 Firebase Cloud Messaging',
    pushSetupRequired: '需要设置',
    pushSetupDesc: '前往 Firebase 控制台→项目设置→服务账号→生成新私钥。下载 JSON 文件并在下方上传。',
    serviceAccountCredentials: '服务账号凭据',
    clientTokenStatus: '客户端令牌状态',
    clientTokenDesc: '推送令牌在客户通过移动/网页登录时自动注册，无需手动配置。',
    testPush: '测试推送',
    webAppConfig: '网页应用配置',
    webAppConfigured: '已配置——{project}',
    webAppRequired: '浏览器和移动端推送必需',
    webAppWhereToFind: '在哪里找到这些',
    webAppWhereToFindDesc: 'Firebase 控制台→项目设置→您的应用→网页应用→SDK 设置和配置',
    saveWebConfig: '保存网页配置',
    vapidKey: 'VAPID 密钥',
    vapidKeyHint: '——Cloud Messaging 标签→Web 推送证书→生成密钥对',
    credentialsOnFile: '凭据已存档',
    credentialsStoredSecurely: '安全存储在服务器上',
    replaceCredentials: '替换',
    uploadServiceAccount: '上传服务账号 JSON',
    uploadServiceAccountHint: '点击选择——文件将被验证并安全存储在服务器上',
    uploadingValidating: '上传并验证中...',
    uploadSuccess: 'Firebase 凭据已成功上传',
    uploadFailed: '上传失败——请检查文件是否为有效的 Firebase 服务账号 JSON',
    saveWebConfigSuccess: 'Firebase 网页配置已保存',
    saveWebConfigFailed: '保存网页配置失败',
    smsTwilio: '短信（Twilio）',
    smsTwilioSubtitle: '通过 Twilio 向有电话号码的客户发送短信提醒',
    smsSetupRequired: '需要设置',
    smsSetupDesc: '从 console.twilio.com→账户→API 密钥和令牌获取您的凭据。您还需要一个 Twilio 电话号码。',
    accountSid: '账户 SID',
    accountSidHint: '以 AC 开头...',
    authToken: '授权令牌',
    fromPhoneNumber: '发件人电话号码',
    fromPhoneHint: 'E.164 格式，例如 +12025551234',
    sendTestSms: '发送测试短信',
    statusConnected: '已连接',
    statusError: '错误',
    statusUntested: '未测试',
    statusTesting: '测试中...',
    notificationRouting: '通知路由',
    notificationRoutingDesc: '选择每种通知类型使用的渠道',
    noChannelsEnabled: '未启用渠道',
    noChannelsEnabledDesc: '请先启用至少一个渠道以配置通知路由',
    notifMarginCall: '追加保证金',
    notifMarginCallDesc: '账户保证金水平低于阈值时',
    notifLiquidation: '强制平仓',
    notifLiquidationDesc: '持仓被强制平仓时',
    notifDeposit: '存款',
    notifDepositDesc: '存款确认时',
    notifWithdrawal: '提款',
    notifWithdrawalDesc: '提款处理时',
    notifTradeOpened: '开仓',
    notifTradeOpenedDesc: '新建仓位时',
    notifTradeClosed: '平仓',
    notifTradeClosedDesc: '仓位平仓时',
    failedToLoad: '加载通知设置失败',
    failedToSave: '保存失败',
    testSuccess: '{channel} 测试成功——请检查您的收件箱/设备',
    testFailed: '{channel} 测试失败',
  },

  // Upgrade
  upgrade: {
    title: '升级套餐',
    currentPlan: '当前套餐',
    choosePlan: '选择套餐',
    basic: '基础版',
    professional: '专业版',
    enterprise: '企业版',
    perMonth: '/月',
    perYear: '/年',
    monthly: '按月',
    annually: '按年',
    features: '功能',
    selectPlan: '选择套餐',
    currentPlanLabel: '当前套餐',
    upgradeTo: '升级至',
    contactSales: '联系销售',
    unlimitedClients: '无限客户',
    unlimitedAccounts: '无限账户',
    advancedReporting: '高级报告',
    prioritySupport: '优先支持',
    apiAccess: 'API 访问',
    customBranding: '自定义品牌',
    whiteLabel: '白标',
    dedicatedManager: '专属客户经理',
    upgradeAvailable: '可升级',
    plan: '套餐',
    unlock: '解锁',
    apiAccessFeature: '、API 访问',
    andMore: '及更多',
    renew: '续费',
  },

  // Theme
  theme: {
    light: '浅色模式',
    dark: '深色模式',
    toggle: '切换主题',
  },

  // Language
  language: {
    english: 'English',
    arabic: 'العربية',
    turkish: 'Türkçe',
    select: '选择语言',
  },

  // Errors
  errors: {
    general: '出现错误',
    networkError: '网络错误，请检查您的连接。',
    unauthorized: '未授权，请重新登录。',
    forbidden: '访问被拒绝。',
    notFound: '资源未找到。',
    serverError: '服务器错误，请稍后重试。',
    actionFailed: '操作失败',
  },

  // Success messages
  success: {
    saved: '保存成功',
    updated: '更新成功',
    deleted: '删除成功',
    created: '创建成功',
    copied: '已复制到剪贴板',
  },

  // Time & Date
  time: {
    seconds: '秒',
    minutes: '分钟',
    hours: '小时',
    days: '天',
    weeks: '周',
    months: '个月',
    years: '年',
    ago: '前',
    justNow: '刚刚',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
  },

  // Units
  units: {
    usd: '美元',
    eur: '欧元',
    gbp: '英镑',
    lot: '手',
    lots: '手',
    pips: '点',
    percent: '%',
  },

  cascade: {
    settingsArchitecture: '设置架构',
    title: '级联优先级系统',
    subtitle: '设置从最高优先级→最低优先级解析。将字段留',
    subtitleNull: '空（NULL）',
    subtitleFallthrough: '以跳过该层并传递至下一层。',
    resolutionOrder: '解析顺序：',
    firstNonNull: '第一个非空值优先',
    highestPriority: '最高优先级——点击任意层探索',
    ifEmptyFallsThrough: '↓ 若为空，则传递',
    priority: '优先级',
    leaveFieldEmpty: '将任意字段留空（NULL）',
    skipLayer: '以跳过此层并传递至',
    finalFallback: '最终回退——下方无更多层。',
    hardLimitsNote: '标有',
    hardLimitsNote2: '的字段为系统级硬性限制，任何层均无法绕过。',
    layers: {
      userOverride: '用户覆盖',
      userSublabel: '针对客户的特殊设置',
      userTooltip: '最高优先级。此处设置的任何字段将覆盖其他所有设置。用于 VIP 客户、受限账户或特殊处理。',
      userFallsTo: '账户组（P2）',
      accountGroup: '账户组',
      groupSublabel: 'VIP、标准、专业等级',
      groupTooltip: '应用于此组中的所有客户。若无用户覆盖，则应用组设置。适合分层账户类型。',
      groupFallsTo: '品种设置（P3）',
      symbolSettings: '品种设置',
      symbolSublabel: '每个交易品种的经纪商配置',
      symbolTooltip: '控制每个交易品种的定价和执行规则。例如 XAUUSD 与 EURUSD 有不同的点差加成。',
      symbolFallsTo: '平台默认（P4）',
      platformDefaults: '平台默认',
      platformSublabel: '系统回退和硬性上限',
      platformTooltip: '默认值的最低优先级，但强制执行其他层无法覆盖的绝对硬性上限。仅由系统管理员管理。',
    },
    setByBroker: '由经纪商设置',
    setBySystemAdmin: '由系统管理员设置',
    goToClients: '前往客户',
    goToAccountGroups: '前往账户组',
    goToInstruments: '前往交易品种',
    fields: {
      maxLeverage: '最大杠杆',
      maxLotSize: '最大手数',
      marginCallLevel: '追加保证金水平',
      stopOutLevel: '强平水平',
      maxOpenPositions: '最大未平仓数',
      commissionPerLot: '每手佣金',
      tradingDisabled: '禁止交易',
      spreadMarkup: '点差加成',
      swapMarkup: '隔夜利息加成',
      tripleSwapDay: '三倍隔夜利息日',
      stopLevel: '止损水平',
      freezeLevel: '冻结水平',
      defaultLeverage: '默认杠杆',
      defaultCommission: '默认佣金',
      defaultMarginCall: '默认追加保证金',
      defaultStopOut: '默认强平',
      maxLeverageCap: '最大杠杆上限',
      minMarginCall: '最低追加保证金',
      minStopOut: '最低强平',
      maxCommissionCap: '最大佣金上限',
      maxPositionsCap: '最大持仓上限',
    },
    fieldDescs: {
      capLeverageClient: '限制此特定客户的杠杆',
      limitPositionSize: '限制每笔交易的仓位大小',
      overrideAlertThreshold: '覆盖警报阈值',
      overrideAutoClose: '覆盖自动平仓阈值',
      limitConcurrentTrades: '限制并发交易数',
      customCommission: '自定义佣金率（如 VIP = 0）',
      killSwitch: '此客户的紧急停止开关',
      groupCommission: '组级别佣金率',
      groupLeverage: '组杠杆上限',
      groupMarginCall: '组警报阈值',
      groupStopOut: '组自动平仓阈值',
      groupPositions: '组持仓限制',
      groupLotSize: '组交易规模限制',
      pipsAddedSpread: '添加到原始点差的点数',
      symbolCommission: '品种特定佣金',
      overnightSwap: '添加到隔夜掉期率',
      tripleSwapDay: '收取三倍掉期的日期',
      symbolLeverage: '品种杠杆上限',
      symbolLotSize: '品种交易规模限制',
      minSlTpDistance: '最小止损/止盈距离（点）',
      modificationFreeze: '修改冻结距离',
      fallbackLeverage: '若无层设置时的回退',
      fallbackCommission: '回退佣金率',
      fallbackMarginCall: '回退警报水平',
      fallbackStopOut: '回退自动平仓水平',
      hardCeilingLeverage: '硬性上限——任何层均不能超过',
      hardFloorMarginCall: '硬性下限——任何层均不能低于',
      hardFloorStopOut: '硬性下限——任何层均不能低于',
      hardCeilingCommission: '佣金硬性上限',
      systemPositionLimit: '系统级持仓限制',
    },
  },

  emailTemplates: {
    loadingTemplates: '加载邮件模板中…',
    loadingTemplate: '加载模板中…',
    retry: '重试',
    allTemplates: '← 所有模板',
    customised: '已自定义',
    custom: '自定义',
    default: '默认',
    subjectLine: '邮件主题',
    subjectPlaceholder: '邮件主题…',
    editorTab: '编辑器',
    htmlTab: 'HTML',
    previewTab: '预览',
    variables: '变量：',
    showLess: '显示更少',
    clickToInsert: '点击插入变量：',
    saveTemplate: '保存模板',
    savingTemplate: '保存中…',
    resetToDefault: '重置为默认',
    resetting: '重置中…',
    back: '返回',
    resetConfirm: '重置为默认高级模板？您的自定义内容将丢失。',
    subjectBodyRequired: '主题和正文为必填项',
    activeBranding: '当前品牌设置',
    companyName: '公司名称',
    primaryColor: '主色调',
    logoUrl: '标志 URL',
    noLogoSet: '未设置标志',
    emailFooter: '邮件页脚',
    brandingNote: '要更新您的品牌设置，请前往经纪商设置。更改将自动应用于所有邮件模板。',
    editBranding: '编辑品牌设置',
    closeBranding: '关闭品牌设置',
    templateListDesc: '点击模板进行编辑。已自定义的模板将覆盖高级默认模板。',
    templateInfoNote: '标记为默认的模板使用内置高级设计并应用您的品牌设置。点击任意模板进行自定义。在编辑器中使用"重置为默认"可恢复更改。',
    loadingBranding: '加载品牌设置中…',
    typeDepositApproved: '存款已批准',
    typeDepositRejected: '存款已拒绝',
    typeWithdrawalApproved: '提款已批准',
    typeWithdrawalRejected: '提款已拒绝',
    typeMarginCall: '追加保证金',
    typeLiquidation: '账户已强平',
    typeKycApproved: 'KYC 已批准',
    typeKycRejected: 'KYC 已拒绝',
    typeWelcome: '欢迎邮件',
  },

  credits: {
    activeRules: '活跃规则',
    totalAwarded: '总奖励',
    awardEvents: '奖励事件',
    bonusRules: '奖励规则',
    awardHistory: '奖励历史',
    newRule: '新建规则',
    manualAward: '手动奖励',
    noBonusRules: '尚无奖励规则。添加一个以开始在存款时自动奖励信用额度。',
    noCreditAwards: '尚无信用额度奖励。',
    deactivateConfirm: '停用此规则？',
    revokeReason: '撤销原因（可选）：',
    operationFailed: '操作失败',
    bonusRuleTitle: '{mode} 奖励规则',
    ruleName: '规则名称（如欢迎奖励）',
    percentOfDeposit: '存款百分比（如 20）',
    fixedAmountUsd: '固定金额（美元）',
    maxCreditCap: '最大信用上限（可选）',
    minDepositQualify: '最低符合条件存款金额',
    expiresAfterDays: 'N 天后到期（可选）',
    ruleActive: '活跃——在符合条件的存款时自动奖励',
    ruleDisabled: '已禁用',
    savingDots: '保存中…',
    awardingDots: '奖励中…',
    manualCreditAward: '手动信用额度奖励',
    accountId: '账户 ID',
    userId: '用户 ID',
    amountUsd: '金额（美元）',
    notesOptional: '备注（可选）',
    awardCredit: '奖励信用额度',
    infoWelcomeDeposit: '欢迎和存款规则在存款批准时自动触发。好意和促销规则为手动奖励。强制平仓时信用额度将被清除。',
    bonusWelcome: '欢迎',
    bonusDeposit: '存款',
    bonusGoodwill: '好意',
    bonusPromotion: '促销',
    statusRevoked: '已撤销',
    statusExpired: '已过期',
  },

  pages: {
    websitePages: '网站页面',
    websitePagesDesc: '构建和管理您的网站。',
    pluginNotActive: '插件未激活。',
    viewPlugins: '查看插件',
    mainPages: '主要页面',
    legalPages: '法律页面',
    langs: '语言',
    save: '保存',
    saved: '已保存',
    error: '错误',
    publish: '发布',
    unpublish: '取消发布',
    published: '已发布',
    draft: '草稿',
    tabBlocks: '块',
    tabSeo: 'SEO',
    addBlock: '添加块',
    addFirstBlock: '添加第一个块',
    addFirstBlockHint: '添加您的第一个内容块',
    noBlocks: '暂无块',
    pageTitle: '页面标题',
    pageTitleHint: '这是导航和页面标题中显示的主标题',
    translatable: '可翻译',
    pageSlug: '页面路径',
    seoTitle: 'SEO 标题',
    seoDescription: 'SEO 描述',
    googlePreview: '谷歌预览',
    noDescription: '无描述。',
    catHeroLayout: '主图和布局',
    catContent: '内容',
    catFeaturesData: '功能和数据',
    catSocialProof: '社交证明',
    catCta: '行动号召',
    catDocuments: '文件和法律',
    catOther: '其他',
    missing: '缺失',
    add: '添加',
    addItem: '添加项目',
    item: '项目',
    notStarted: '未开始',
  },

  userOverride: {
    title: '用户账户覆盖',
    infoBannerTitle: '用户级别覆盖（第 1 层）',
    infoBannerDesc: '这些设置将覆盖用户账户组的默认设置。留空（NULL）将使用组设置。',
    sectionTradingControl: '交易控制',
    sectionRiskParameters: '风险参数',
    sectionPricingOverrides: '定价覆盖',
    disableTrading: '禁止交易',
    disableTradingSubLabel: '阻止此用户开仓',
    resetToGroupDefault: '重置为组默认',
    groupDefault: '组默认',
    maxLeverage: '最大杠杆',
    maxLotSize: '最大手数',
    minLotSize: '最小手数',
    marginCallLevel: '追加保证金水平（%）',
    stopOutLevel: '强平水平（%）',
    maxOpenPositions: '最大未平仓数',
    commissionPerLot: '每手佣金（美元）',
    commissionPerLotHint: '每标准手交易收取的美元费用',
    minAboveMaxError: '⚠️ 最小手数不能超过最大手数',
    currentOverrideTitle: '当前覆盖已激活',
    currentOverrideDesc: '此用户拥有自定义设置，覆盖其账户组的默认设置。',
    saveOverride: '保存覆盖',
    saving: '保存中...',
    saveSuccess: '用户覆盖已成功保存',
    saveFailed: '保存用户覆盖失败',
    lots: '手',
    lotStep: '手数步长',
  },

  symbolSettings: {
    sectionPricing: '经纪商定价',
    sectionRisk: '风险限制',
    sectionExecution: '执行规则',
    sectionOverrides: '品种覆盖',
    sectionsLabel: '部分',
    pricingDesc: '在此经纪商的原始品种利率之上应用的调整。',
    riskDesc: '在此经纪商层面应用的持仓和杠杆限制。',
    executionDesc: '订单下达和修改限制。',
    overridesDesc: '切换每个字段以激活经纪商级别的覆盖。禁用的字段将回退到共享品种表。',
    overridesInfoTitle: '多头掉期/空头掉期',
    overridesInfoDesc: '启用时将完全替换品种利率——掉期加成不会叠加计算。所有其他覆盖按正常级联处理。',
    settingsTitle: '{symbol} 设置',
    headerSubtitle: '配置经纪商级别定价和风险（第 3 层）',
    overrideActive: '{count} 个覆盖已激活',
    overridesActive: '{count} 个覆盖已激活',
    spreadMarkup: '点差加成',
    spreadMarkupHint: '在流动性提供商的原始点差上添加的点数',
    commissionPerLot: '每手佣金',
    commissionPerLotHint: '每标准手交易收取的美元费用',
    swapMarkup: '掉期加成',
    swapMarkupHint: '添加到品种掉期率之上的点数。启用多头/空头掉期覆盖时忽略。',
    tripleSwapDay: '三倍掉期日',
    tripleSwapDayHint: '收取三倍掉期的日期',
    maxLeverage: '最大杠杆',
    maxLeverageHint: '此品种允许的最大杠杆',
    maxLotSize: '最大手数',
    maxLotSizeHint: '每笔交易的最大仓位大小',
    minLotSize: '最小手数',
    minLotSizeHint: '每笔交易的最小仓位大小',
    minAboveMaxError: '⚠️ 最小手数不能超过最大手数',
    stopLevel: '止损水平',
    stopLevelHint: '止损/止盈距当前市场价格的最小距离（点）',
    freezeLevel: '冻结水平',
    freezeLevelHint: '冻结订单修改的距离（点）',
    contractSize: '合约规模',
    contractSizeHint: '每手单位数。例如标准外汇为 100000，股票为 1。',
    priceScale: '价格精度',
    priceScaleHint: '价格报价的小数位数。5 = 1.23456，2 = 1.23。',
    swapLong: '多头掉期（直接利率）',
    swapLongHint: '买入持仓的隔夜利率。完全替换品种利率。',
    swapShort: '空头掉期（直接利率）',
    swapShortHint: '卖出持仓的隔夜利率。完全替换品种利率。',
    swapMode: '掉期模式',
    swapModeHint: '隔夜掉期利率的计算方式',
    maxVolume: '最大交易量（手）',
    maxVolumeHint: '此经纪商单笔最大交易规模（手）。',
    volumeStep: '交易量步长（手）',
    volumeStepHint: '最小交易规模增量。例如 0.01 允许 0.01、0.02、0.03…',
    defaultBadge: '默认',
    pips: '点',
    pts: '点数',
    lots: '手',
    decimals: '小数位',
    dayMon: '周一',
    dayTue: '周二',
    dayWed: '周三',
    dayThu: '周四',
    dayFri: '周五',
    daySat: '周六',
    daySun: '周日',
    loadingSettings: '加载设置中…',
    saveSettings: '保存设置',
    lotStep: '手数步长',
  },

  accountGroupForm: {
    sectionsLabel: '部分',
    sectionBasic: '基本信息',
    sectionPricing: '定价覆盖',
    sectionRisk: '风险管理',
    editTitle: '编辑账户组',
    createTitle: '创建账户组',
    basicInfoTitle: '基本信息',
    groupNameLabel: '组名称 *',
    groupNamePlaceholder: '标准组',
    descriptionLabel: '描述',
    descriptionPlaceholder: '组描述...',
    groupActive: '组已激活',
    defaultGroup: '默认组',
    pricingTitle: '定价覆盖',
    pricingDesc: '留空则使用经纪商级别默认值。仅在此组需要不同定价时进行覆盖。',
    commissionPerLot: '每手佣金（美元）',
    commissionPerLotHint: '每标准手交易收取的美元费用',
    maxLeverage: '最大杠杆',
    maxLeverageHint: '此组可用的最大杠杆',
    brokerDefault: '经纪商默认',
    resetToNoLimit: '重置为无限制',
    riskTitle: '风险管理',
    marginCallLevel: '追加保证金水平',
    marginCallHint: '当保证金水平达到此百分比时发出警报',
    stopOutLevel: '强平水平',
    stopOutHint: '在此保证金水平自动平仓',
    maxOpenPositions: '最大未平仓数',
    maxOpenPositionsHint: '每个账户的最大持仓数量',
    maxLotSize: '最大手数',
    maxLotSizeHint: '每笔交易的最大手数',
    minLotSize: '最小手数',
    minLotSizeHint: '此组每笔交易的最小手数',
    noLimit: '无限制',
    lots: '手',
    marginBelowStopError: '⚠️ 追加保证金水平必须大于强平水平',
    minAboveMaxError: '⚠️ 最小手数不能超过最大手数',
    updateGroup: '更新组',
    createGroup: '创建组',
    lotStep: '手数步长',
  },

  cryptoCheckout: {
    paymentConfirmedTitle: '付款已确认！',
    makePayment: '付款',
    depositFunds: '充值',
    purchaseItem: '购买 {name}',
    subscribeTo: '订阅 {name}',
    selectPaymentMethod: '选择付款方式',
    payWith: '使用 {currencies} 付款',
    creatingPayment: '创建付款中...',
    continue: '继续',
    sendExactly: '精确发送',
    approxUsd: '≈ ${amount} 美元',
    hideQrCode: '隐藏二维码',
    showQrCode: '显示二维码',
    scanWithWallet: '使用移动钱包扫描',
    toThisAddress: '至此 {network} 地址',
    expiresIn: '到期时间',
    waitingForPayment: '等待付款...',
    waitingDesc: '发送精确金额，我们将自动检测。',
    verifiedOnChain: '由 AmorPay 链上验证，无中间商。',
    pluginActivated: '{name} 已激活。',
    depositCredited: '您的存款已记入账户。',
    subscriptionActive: '您的订阅现已激活。',
    paymentConfirmed: '您的付款已确认。',
    done: '完成',
    noItemSelected: '未选择购买项目',
    failedToLoadOptions: '加载支付选项失败',
  },

  subscriptionGate: {
    accountSuspended: '账户已暂停',
    subscriptionExpired: '订阅已过期',
    suspendedDesc: '您的账户已被暂停，请联系支持以恢复访问权限。',
    expiredDesc: '您的 {plan} 订阅已过期且宽限期已结束。续费以恢复完整访问权限。',
    renewSubscription: '续费订阅',
    signOut: '退出登录',
    needHelp: '需要帮助？请联系',
    lastChance: '⚠️ 最后机会！您的 {plan} 订阅已过期。今天访问权限将结束。',
    gracePeriodDay: '您的 {plan} 订阅已过期。宽限期还剩 {days} 天。',
    gracePeriodDays: '您的 {plan} 订阅已过期。宽限期还剩 {days} 天。',
    renewNow: '立即续费',
  },

  upgradePage: {
    renewTitle: '续费订阅',
    upgradeTitle: '升级您的套餐',
    currentlyOn: '当前使用',
    graceDaysLeft: '宽限期还剩 {days} 天',
    graceDaysLeftPlural: '宽限期还剩 {days} 天',
    expired: '已过期',
    graceWarning: '您的订阅已过期。在账户锁定前还有 {days} 天续费。',
    graceWarningPlural: '您的订阅已过期。在账户锁定前还有 {days} 天续费。',
    expiredWarning: '您的订阅已完全过期。立即续费以恢复访问权限。',
    renewOrUpgrade: '您可以续费当前套餐或升级到更高级别。',
    monthly: '按月',
    yearly: '按年',
    mostPopular: '最受欢迎',
    currentPlan: '当前套餐',
    perMonth: '/月',
    saveYearly: '节省 10%——按 ${amount}/年计费',
    unlimitedTraders: '无限交易者',
    tradersCount: '{count} 位交易者',
    unlimitedAdmins: '无限管理员',
    adminsCount: '{count} 位管理员',
    unlimitedInstruments: '无限交易品种',
    instrumentsCount: '{count} 个交易品种',
    feedUltra: '超低延迟行情',
    feedPriority: '优先行情',
    feedStandard: '标准行情',
    fullApiAccess: '完整 API 访问',
    selected: '已选',
    selectPlan: '选择套餐',
    fullComparison: '完整对比',
    featureCol: '功能',
    featureTraders: '交易者',
    featureAdmins: '管理员',
    featureInstruments: '交易品种',
    featureFeedLatency: '行情延迟',
    featureApiAccess: 'API 访问',
    featureForex: '外汇',
    featureCrypto: '加密货币',
    featureCommodities: '大宗商品',
    featureIndices: '指数',
    featureStocks: '股票',
    selectedPlan: '已选：',
    selectToContinue: '请选择套餐以继续',
    perYear: '/年',
    renewNow: '立即续费',
    upgradeNow: '立即升级',
    failedToLoadPlans: '加载套餐失败',
    selectPlanFirst: '请先选择套餐',
    planActivated: '{name} 套餐已激活！🎉',
  },
  sidebar: {
    sectionOverview: '概览',
    sectionManagement: '管理',
    sectionTrading: '交易',
    sectionFinance: '财务',
    sectionPlugins: '插件',
    sectionSystem: '系统',
    accountGroups: '账户组',
    cascadeGuide: '级联指南',
    pluginStore: '插件商店',
    kycVerification: 'KYC 验证',
    kycDashboard: 'KYC 仪表板',
    kycConfig: 'KYC 配置',
    pages: '页面',
    credits: '积分',
    emailTemplates: '邮件模板',
    restApi: 'REST API',
    advancedAnalytics: '高级分析',
    descClients: '用户 · 设置 · 覆盖',
    descGroups: '组 · 设置 · 覆盖',
    descInstruments: '经纪商 · 设置 · 覆盖',
    descAccounts: '账户与余额',
    descCascade: '优先级系统说明',
    descAnalytics: 'AI 驱动的洞察',
    badgeLive: '实时',
    badgeActive: '活跃',
    badgeAddon: '扩展',
    badgePro: 'PRO',
    badgeApi: 'API',
    badgeConfig: '配置',
    badgeHowItWorks: '工作原理',
    cascadeTipFallthrough: '将字段留空以传递到下一层',
  },
};